export default function ValidationMessage({ 
    validationState = { status: 'idle', message: '', isValid: true },
    className = "mt-2 text-sm"
}) {
    const { status, message, isValid } = validationState;

    if (!message || status === 'idle') {
        return null;
    }

    // Función para obtener las clases de color según el estado
    const getMessageClasses = () => {
        switch (status) {
            case 'validating':
                return 'text-blue-600 dark:text-blue-400';
            case 'valid':
                return 'text-green-600 dark:text-green-400';
            case 'invalid':
            case 'error':
                return 'text-red-600 dark:text-red-400';
            default:
                return 'text-gray-600 dark:text-gray-400';
        }
    };

    return (
        <div className={`${className} ${getMessageClasses()} flex items-center gap-2`}>
            {status === 'validating' && (
                <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
            )}
            
            {status === 'valid' && (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
            )}
            
            {(status === 'invalid' || status === 'error') && (
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            )}
            
            <span>{message}</span>
        </div>
    );
}
